import { HeaderModelData, Region } from 'types/model';
import { selectCurrentRegion } from 'selectors/model';

export interface UseRegionsReturnType {
  regions: Region[];
  currentRegion: Region | null;
  defaultRegion: Region;
}

const createDefaultRegion = (regions: Region[]): Region => {
  if (regions.length === 0) {
    // HACK: NAVI-5903
    return {
      regionId: '34',
      regionCode: 'moscow',
      regionName: 'Москва, Московская область',
      currentPageLink: '',
    };
  }

  return regions[0];
};

export const useRegions = (model: HeaderModelData): UseRegionsReturnType => {
  const {
    regions,
    properties: { regionId },
  } = model;

  const currentRegion = selectCurrentRegion(regions, regionId);
  const defaultRegion = createDefaultRegion(regions);

  return {
    regions,
    currentRegion,
    defaultRegion,
  };
};
